// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {GooglePayProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';
import {containerTemplate} from '../container';
import {validateComponentProps} from '../utils';
import {getPaymentMethods} from '../api';

export * from './types';

const options: ComponentOptionsType<GooglePayProps> = {
  tag: 'monei-google-pay',
  url: config.googlePayUrl,
  dimensions: {
    width: '100%',
    height: '0'
  },
  autoResize: {
    width: false,
    height: true
  },
  validate: validateComponentProps,
  containerTemplate,
  prerenderTemplate: () => undefined,
  props: {
    accountId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    sessionId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    amount: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    currency: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onSubmit: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onBeforeSubmit: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    },
    __getConfig: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props}: any) => {
        return getPaymentMethods.bind(null, props);
      }
    }
  }
};

export const GooglePay: MoneiComponent<GooglePayProps> = zoid.create(options);
